import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";


export default function Rdp() {
  const navigate = useNavigate();

  const getAndSetReferalCode = () => {
    let location = window.location.href.toLowerCase()
    let splitUrl = location.split("/referral/rdp/")
    if (splitUrl.length > 1) {
      let code = splitUrl.slice(-1)
      let newCode = code[0].split("?")
      localStorage.setItem("registerCode", JSON.stringify(newCode[0]));
    }
    navigate("/")
  }
  useEffect(() => {
    getAndSetReferalCode();
  }, []);

  return (
    <>
      {/* {loadPage ? <Redirect to="/" /> : null}   */}
    </>
  );
}
